////////////////////////////////////////////
// DEEPLINK TOAST — OUTCOME OF A WALLET-APP ROUND TRIP
////////////////////////////////////////////
//
// A DEEPLINK FLOW FINISHES ON A FRESH DOCUMENT (SUBMIT/VERIFY RUN DURING
// LOAD), SO THE PANEL THAT STARTED IT IS GONE — THIS GLOBAL PILL IS WHERE
// "committed ✓" / "Cancelled in the wallet app." LAND. MOUNTED ONCE IN
// PageShell; READS THE MODULE-LEVEL STORE SO A RESULT THAT ARRIVED BEFORE
// MOUNT STILL SHOWS.
import { useEffect, useSyncExternalStore } from "react";
import { dismissDlToast, dlToast, subscribeDlToast } from "@/lib/wallet/deeplink/resume";

const TONE: Record<string, string> = {
  ok: "border-green/50 text-green",
  err: "border-red-500/50 text-red-400",
  info: "border-line text-fg",
};

export function DlToast() {

  const t = useSyncExternalStore(subscribeDlToast, dlToast);

  // AUTO-DISMISS — LONG ENOUGH TO READ A TX SIGNATURE PREFIX
  useEffect(() => {

    if (!t)
      return;
    const id = setTimeout(dismissDlToast, 8000);
    return () => clearTimeout(id);
  }, [t]);

  if (!t)
    return null;

  return (
    <div
      role="status"
      className={
        "fixed left-1/2 -translate-x-1/2 bottom-[calc(18px+env(safe-area-inset-bottom,0px))] z-[1300] " +
        "max-w-[92vw] px-4 py-[10px] rounded-full bg-panel border shadow-[0_10px_30px_rgba(0,0,0,.5)] " +
        "font-mono text-[12.5px] cursor-pointer " + (TONE[t.cls] || TONE.info)
      }
      onClick={dismissDlToast}
    >
      {t.text}
    </div>
  );
}
